function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.28 5.28h7.92v7.92H5.28V5.28z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0h18.48v18.48H0V0zm15.84 15.84V2.64H2.64v13.2h13.2z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.12 0h5.28v2.64h-5.28V0zM34.32 0h2.64v5.28h5.28V0h2.64v7.92h-2.64v2.64h2.64v10.56h2.64v2.64H39.6v-5.28h2.64V13.2H39.6v5.28h-2.64v-2.64h-2.64v2.64h-2.64V13.2h2.64V7.92h-2.64v5.28H26.4v2.64h-2.64V13.2h-2.64V5.28h2.64v2.64h2.64v2.64h2.64V5.28h5.28V0z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.76 18.48h-2.64v-2.64h2.64v2.64zM50.16 47.52h-2.64v2.64h2.64v-2.64z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.4 18.48h-2.64v2.64h-2.64v2.64h-2.64v-2.64h-2.64v2.64h-5.28v-2.64H0v5.28h2.64v5.28H0v2.64h2.64v5.28H0v2.64h2.64V39.6h5.28v2.64H5.28v2.64h2.64v-2.64h2.64v2.64h10.56v2.64h2.64v-2.64h-2.64v-2.64h2.64V39.6h5.28v-2.64h2.64v5.28H26.4v2.64h5.28v2.64h-2.64v2.64h2.64v2.64H26.4v-2.64h-2.64v5.28h-2.64V66h7.92v-2.64h-5.28v-5.28h2.64v2.64h10.56v-2.64h2.64v-2.64h-2.64V52.8h-2.64v-5.28h2.64v-2.64h-5.28v-2.64h5.28V39.6h2.64v5.28h2.64v5.28H39.6v2.64h2.64v5.28h2.64v2.64h2.64v2.64h-2.64V66H66v-2.64h-5.28v-2.64h2.64v-2.64H66v-2.64h-2.64v-5.28H66V39.6h-2.64v-2.64H66v-5.28h-5.28v-2.64h-5.28V26.4H52.8v-2.64h7.92v2.64h2.64v-2.64H66v-2.64h-2.64v2.64h-2.64v-2.64H52.8v2.64h-2.64v2.64h2.64v2.64h-2.64v2.64h-2.64V26.4h-5.28v2.64h-5.28v-5.28h-2.64v5.28h-5.28v5.28H26.4v-2.64h-5.28v-7.92h2.64v2.64h2.64v-2.64h-2.64v-2.64h2.64v-2.64zm-7.92 13.2h2.64v2.64h5.28v2.64h-2.64v2.64h-5.28v-2.64H13.2v-2.64h5.28v-2.64zM13.2 39.6v2.64h5.28V39.6H13.2zm0 0v-2.64h-2.64v-5.28h7.92v-2.64h-7.92v-5.28H5.28v5.28h2.64V39.6h5.28zm29.04-10.56h2.64v2.64h-2.64v-2.64zm7.92 2.64h2.64v2.64h-2.64v-2.64zm13.2 5.28v-2.64h-5.28v-2.64h-2.64v10.56h7.92V39.6h-5.28v-2.64h5.28zM42.24 39.6H39.6v-2.64h2.64v2.64zm0 0h2.64v2.64h-2.64V39.6zm-7.92-2.64v-2.64h5.28v-2.64h-7.92v5.28h2.64zm0 0v2.64h2.64v-2.64h-2.64zM26.4 58.08h5.28v-2.64H26.4v2.64zM2.64 34.32h2.64v-2.64H2.64v2.64zm13.2-10.56h2.64v2.64h-2.64v-2.64zm42.24 39.6h-2.64v-5.28h2.64v5.28zm-5.28 0h-2.64v-7.92h2.64v7.92zm5.28-7.92h2.64v-5.28h-2.64v-5.28h-2.64v7.92h2.64v2.64zM52.8 52.8h-7.92v-7.92h7.92v7.92zm7.92-5.28h2.64v-2.64h-2.64v2.64zM50.16 39.6h2.64v-2.64h-2.64v2.64z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.04 18.48v2.64h2.64v-2.64h-2.64zM29.04 18.48H26.4v-2.64h2.64v2.64zM52.8 5.28h7.92v7.92H52.8V5.28z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.52 0H66v18.48H47.52V0zm15.84 15.84V2.64h-13.2v13.2h13.2z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.28 52.8v7.92h7.92V52.8H5.28z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 47.52V66h18.48V47.52H0zm15.84 15.84v-13.2H2.64v13.2h13.2z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.24 60.72H39.6v2.64h-2.64V66h2.64v-2.64h2.64v-2.64zM34.32 63.36h-2.64V66h2.64v-2.64z"
});

var SvgQrCode = function SvgQrCode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgQrCode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/qr-code.c78a7993.svg";
export { ForwardRef as ReactComponent };